import { render } from "./InputAyandeh.vue?vue&type=template&id=c326162e"
import script from "./InputAyandeh.vue?vue&type=script&lang=js"
export * from "./InputAyandeh.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__